module.exports = __webpack_public_path__ + "fonts/pt_serif-web-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/PT_Serif/pt_serif-web-regular-webfont.woff2
// module id = 3449
// module chunks = 0